import { Navigate, useSearchParams } from 'react-router-dom';

/** Seeded default cover letter template (see backend db_init.COVER_LETTER_TEMPLATE_ID). */
export const COVER_LETTER_TEMPLATE_ID = 'cover-letter-classic';
export const COVER_LETTER_TEMPLATE_NAME = 'Cover Letter Classic';
export const COVER_LETTER_DOC_SLUG = 'cover-letter';

export function isCoverLetterDocumentType(documentType) {
  const key = String(documentType || '').trim().replace(/-/g, '_');
  return key === 'cover_letter';
}

/**
 * Build the cover letter generate URL with the classic template pre-selected.
 * @param {Record<string, string>} [extraParams] — e.g. rerunJobId
 */
export function buildCoverLetterGeneratePath(extraParams = {}) {
  const params = new URLSearchParams({
    templateId: COVER_LETTER_TEMPLATE_ID,
    templateName: COVER_LETTER_TEMPLATE_NAME,
  });
  Object.entries(extraParams).forEach(([key, value]) => {
    if (value != null && String(value).trim() !== '') {
      params.set(key, String(value));
    }
  });
  return `/documents/${COVER_LETTER_DOC_SLUG}/generate?${params.toString()}`;
}

/** Router redirect — bypasses template selection for the single cover letter template. */
export function CoverLetterTemplateRedirect() {
  const [searchParams] = useSearchParams();
  const extra = Object.fromEntries(searchParams.entries());
  return <Navigate to={buildCoverLetterGeneratePath(extra)} replace />;
}
